import { useSelector } from "react-redux";

const useAuth = () => {
  const user = useSelector((state) => state.user.user);
  const profile_image = useSelector((state) => state.profile.profile_image);
  const seller = useSelector((state) => state.seller);
  const explore = useSelector((state) => state.explore);
  const cart = useSelector((state) => state.cart.cart);
  const favourite = useSelector((state) => state.favourite.favourite);
  const backdrop = useSelector((state) => state.sellerhub.backdrop);
  const transactionIndividual = useSelector(
    (state) => state.sellerhub.transactionIndividual
  );
  const inventoryIndividual = useSelector(
    (state) => state.sellerhub.inventoryIndividual
  );

  return {
    user,
    seller,
    explore,
    cart,
    favourite,
    profile_image,
    backdrop,
    transactionIndividual,
    inventoryIndividual,
  };
};

export default useAuth;
